import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { map, Observable, startWith } from "rxjs";
import { CommonHelperComponent } from "src/app/common-helper/common-helper.component";
import { TruckOwnerService } from "../truck-owner.service";

@Component({
  selector: "app-mapping",
  templateUrl: "./mapping.component.html",
  styleUrls: ["./mapping.component.css"],
})
export class MappingComponent implements OnInit {
  token: any;
  mappings: FormGroup;
  trucksList: any;
  driverList: any;
  filteredTrucks: Observable<any[]>;
  filteredDriver: Observable<any[]>;
  truckControl: FormControl;
  driverControl: FormControl;
  selectedTruck: any;
  selectedDriver: any;
  fetch_page: any = 0;
  currentPage: any = 0;
  total_cat_count: any;
  startPage: any = 1;
  last_page: any = 1;
  mappingList: any;
  document_array: any = [];
  perPage: any = 10;
  page: any = 1;
  searchTruckNumber: any = -1;
  loading: boolean = false;
  search_btn: boolean = true;
  clear_btn: boolean = false;
  @ViewChild("newItem") newItem!: ElementRef;
  constructor(
    private services: TruckOwnerService,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.getMappingList(this.searchTruckNumber);
    this.loadFormGroup();
    this.getTrucksList();
    this.getDriverList();
    this.pagination(1);
    this.truckControl = new FormControl();
    this.driverControl = new FormControl();

    this.driverControl.valueChanges.subscribe((inputValue) => {
      // If the input field is cleared, reset the selected driver
      if (!inputValue) {
        this.selectedDriver = null;
      }
    });
    this.truckControl.valueChanges.subscribe((inputValue) => {
      // If the input field is cleared, reset the selected driver
      if (!inputValue) {
        this.selectedTruck = null;
      }
    });

    let triptype = "mapping";
    sessionStorage.setItem("tripType", triptype);
  }

  getMappingList(type: any) {
    this.searchTruckNumber = type;
    this.loading = true;
    this.services
      .GetMappingsList(
        this.token,
        this.searchTruckNumber,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (list: any) => {
          this.mappingList = list.body.data;
          this.document_array.push(list.body.meta);
          this.last_page = list.body.meta.lastPage;
          this.getTrucksList();
          this.getDriverList();
          this.loading = false;
        },

        (error) => {
          this.loading = false;
          if (error.status == 404) {
            this.mappingList = [];
            return;
          }
          if (error.status == 403) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.status == 401) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  getTrucksList() {
    this.services.GetAvailableTrucks(this.token).subscribe(
      (result) => {
        if (result.status == 200) {
          this.trucksList = result.body.data;
          this.filteredTrucks = this.truckControl.valueChanges.pipe(
            startWith(""),
            map((state) => this.filterTrucks(state || ""))
          );
        }
      },
      (error) => {
        sessionStorage.clear();
        this.router.navigateByUrl("/");
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  getDriverList() {
    this.services.GetAvailableDrivers(this.token).subscribe(
      (result) => {
        if (result.status == 200) {
          this.driverList = result.body.data;
          this.filteredDriver = this.driverControl.valueChanges.pipe(
            startWith(""),
            map((state) => this.filterDrivers(state || ""))
          );
        }
      },
      (error) => {
        sessionStorage.clear();
        this.router.navigateByUrl("/");
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  filterTrucks(searchText: string): any[] {
    const lowerCaseSearchText =
      typeof searchText === "string" ? searchText.toLowerCase() : "";
    return this.trucksList?.filter((truck: any) =>
      truck.truck_number.toLowerCase().includes(lowerCaseSearchText)
    );
  }

  filterDrivers(searchText: string): any[] {
    const lowerCaseSearchText =
      typeof searchText === "string" ? searchText.toLowerCase() : "";
    return this.driverList?.filter((driver: any) =>
      driver.username.toLowerCase().includes(lowerCaseSearchText)
    );
  }

  selectTruck(event: any) {
    this.selectedTruck = event;
    this.truckControl.setValue(event.truck_number);
  }

  selectDriver(option: any) {
    this.selectedDriver = option;
    this.driverControl.setValue(option.username);
  }

  loadFormGroup() {
    this.mappings = this.formBuilder.group({
      truck_id: ["", [Validators.required]],
      driver_id: ["", [Validators.required]],
    });
  }

  addMappings() {
    if (
      this.selectedTruck?._id === undefined ||
      this.selectedTruck?._id === null
    ) {
      this.snackBar.open("Please select truck", "Fail", {
        duration: 3000,
      });
      return;
    }
    if (
      this.selectedDriver?._id === undefined ||
      this.selectedDriver?._id === null
    ) {
      this.snackBar.open("Please select driver", "Fail", {
        duration: 3000,
      });
      return;
    }

    const mappingData = {
      truck_id: this.selectedTruck._id,
      driver_id: this.selectedDriver._id,
    };
    this.services.AddMappings(this.token, mappingData).subscribe(
      (response) => {
        if (response.status == 200) {
          this.getMappingList(this.searchTruckNumber);
          this.mappings.reset();
          this.mappings.clearValidators();
          this.truckControl.reset();
          this.driverControl.reset();
          window.location.reload();
        }
        },

        (error) => {
          if (error.status == 403) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.status == 401) {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("/");
            sessionStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  deleteMapping(mappingData: any) {
    const dialogRef = this.dialog.open(CommonHelperComponent, {
      data: { message: "Are you sure want to delete this mapping." },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res == "yes") {
        this.services.DeleteMappings(this.token, mappingData._id).subscribe(
          (result: any) => {
            if (result.status == 200) {
              this.getMappingList(this.searchTruckNumber);
              this.getTrucksList();
              this.getDriverList();
              this.snackBar.open(result.body.message, "Success", {
                duration: 5000,
              });
            }
          },
          (error) => {
            if (error.status == 403) {
              this.router.navigateByUrl("/");
              sessionStorage.clear();
            }
            if (error.status == 401) {
              this.router.navigateByUrl("/");
              sessionStorage.clear();
            }
            if (error.error.message === "jwt malformed") {
              this.router.navigateByUrl("/");
              sessionStorage.clear();
            }
            if (error.error.message === "jwt expired") {
              this.router.navigateByUrl("/");
              sessionStorage.clear();
            }
            this.snackBar.open(error.error.message, "Fail", {
              duration: 5000,
            });
          }
        );
      }
    });
  }
  pagination(page_status: any) {
    if (page_status == "-1") {
      this.fetch_page = parseInt(this.fetch_page) - 1;
      this.currentPage = this.fetch_page;
      this.startPage = this.currentPage;
    }
    if (page_status == "1") {
      this.currentPage = parseInt(this.fetch_page) + 1;
      this.fetch_page = this.currentPage;
      this.startPage = this.fetch_page;
    }
    if (page_status == "first") {
      this.fetch_page = this.document_array[0].currentPage;
      this.startPage = this.document_array[0].currentPage;
    }
    if (page_status == "last") {
      this.fetch_page = this.document_array[0].lastPage;
      this.startPage = this.document_array[0].lastPage;
    }
    this.getMappingList(this.searchTruckNumber);
  }
  search(type: string) {
    if (type != "") {
      this.search_btn = false;
      this.clear_btn = true;
      this.startPage = 1;
      this.getMappingList(type);
    }
  }

  resetSearch() {
    this.newItem.nativeElement.value = "";
    this.search_btn = true;
    this.clear_btn = false;
    this.searchTruckNumber = -1;
    this.fetch_page = 0;
    this.pagination(1);
    this.getMappingList(this.searchTruckNumber);
  }
}
